"use strict";
/*
 * 8x8 Confidential & Proprietary || Copyright 2025 8x8, Inc. or its affiliates. All Rights Reserved.
 *  _____      _____
 * |  _  |    |  _  |
 *  \ V /__  __\ V /   ___ ___  _ __ ___
 *  / _ \\ \/ // _ \  / __/ _ \| '_ ` _ \
 * | |_| |>  <| |_| || (_| (_) | | | | | |
 * \_____/_/\_\_____(_)___\___/|_| |_| |_|
 *
 * @License https://www.8x8.com/terms-and-conditions/software-development-kit-license-agreement
 * @Author Comanici Paul
 * @Date 2025/08/05
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.initTracking = initTracking;
exports.onFocus = onFocus;
const port_1 = require("./messages/port");
const features_1 = require("./features");
const constants_1 = require("./constants");
const const_1 = require("./messages/const");
/**
 * Send a message to the parent-sdk with the name as "focus-event"
 */
function sendFocusEvent() {
    const data = { type: constants_1.INTERNAL_MESSAGE_TYPE, message: { name: const_1.SEND_INTERNAL_MESSAGE.FOCUS_EVENT } };
    (0, port_1.sendMessage)(data);
}
function onFocus() {
    sendFocusEvent();
}
function initTracking() {
    const isTrackFocusEnabled = (0, features_1.getFeature)("trackFocus");
    if (!isTrackFocusEnabled) {
        return;
    }
    window.addEventListener("focus", onFocus);
}
//# sourceMappingURL=track.js.map